export default {"src":"/_next/static/media/six-art.5628643b.svg","height":70,"width":86,"blurWidth":0,"blurHeight":0};